import { z } from 'zod';
import { zStringRequired } from '../../z';
import { registry } from '../registry';
export const disciplineOptions = [
    { value: 'SN', label: 'Skilled Nursing' },
    { value: 'OT', label: 'Occupational Therapy' },
    { value: 'ST', label: 'Speech Therapy' },
    { value: 'MSW', label: 'Medical Social Worker' },
    { value: 'HHA', label: 'Home Health Aide' },
];
export const impairmentOptions = [
    { value: 'cognitive decline', label: 'Cognitive Decline' },
    { value: 'apraxia', label: 'Apraxia' },
    { value: 'dysphonia', label: 'Dysphonia' },
    { value: 'receptive aphasia', label: 'Receptive Aphasia' },
    { value: 'expressive aphasia', label: 'Expressive Aphasia' },
    { value: 'dysphasia', label: 'Dysphasia' },
    { value: 'dysarthria', label: 'Dysarthria' },
    { value: 'other', label: 'Other' },
];
export const stOutcomeMeasureOptions = [
    { value: 'tinetti', label: 'Tinetti' },
    { value: 'oasis data', label: 'OASIS data' },
    { value: 'inside without assistance', label: 'Inside without assistance' },
    { value: 'other', label: 'Other' },
];
export const baseSTSummary = z.object({
    summary: z.object({
        disciplinesStillProvidingCare: z.array(z.string()).optional().register(registry, {
            label: 'Disciplines still providing care',
            options: disciplineOptions,
        }),
        initialReasonHomeTherapy: z.string().optional().register(registry, { label: 'Initial Reason for Home Therapy' }),
        reasonStillHomebound: z.string().optional().register(registry, { label: 'Reason Still Homebound' }),
        impairmentsStillAddressed: z.array(z.string()).optional().register(registry, {
            label: 'Current Impairments Still Being Addressed',
            options: impairmentOptions,
        }),
        impairmentsStillAddressedOther: z.string().optional().register(registry, { label: 'Specify' }),
    }),
    impairmentSummary: z.object({
        initial: z.string().optional().register(registry, { label: 'Impairment Summary — Initial' }),
        current: z.string().optional().register(registry, { label: 'Impairment Summary — Current' }),
        goal: z.string().optional().register(registry, { label: 'Impairment Summary — Goal' }),
    }),
    functionalSummary: z.object({
        initial: z.string().optional().register(registry, { label: 'Functional Summary — Initial' }),
        current: z.string().optional().register(registry, { label: 'Functional Summary — Current' }),
        goal: z.string().optional().register(registry, { label: 'Functional Summary — Goal' }),
    }),
    outcomeMeasures: z.object({
        measure: z.array(z.string()).optional().register(registry, { label: 'Outcome Measure', options: stOutcomeMeasureOptions }),
        measureOther: z.string().optional().register(registry, { label: 'Specify' }),
        initial: z.string().optional().register(registry, { label: 'Outcome Measure — Initial' }),
        current: z.string().optional().register(registry, { label: 'Outcome Measure — Current' }),
        goal: z.string().optional().register(registry, { label: 'Outcome Measure — Goal' }),
    }),
});
export const stSummaryValidationSchema = z.object({
    id: z.string(),
    data: baseSTSummary,
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
